import { DateTime } from 'luxon';
import { FamilyVM } from 'practice/components/edit/form/step-family/family/table-family';
import { PracticeFamily } from 'shell/models/practice-family';

export const transformFamilyTable = (list?: Array<PracticeFamily>): Array<FamilyVM> => {
  return (list || []).map((subject) => ({
    surname: subject.generalita?.cognome || '',
    name: subject.generalita?.nome || '',
    fiscalCode: subject.generalita?.codiceFiscale?.codFiscale || '',
    birthDate: subject.generalita?.dataNascita
      ? DateTime.fromISO(subject.generalita?.dataNascita).toFormat('dd/MM/yyyy')
      : '',
    relationship: subject.legameSoggetto?.codiceLegame || '',
    birthplace:
      (subject.generalita?.luogoNascita?.localita
        ? subject.generalita?.luogoNascita?.localita?.descrizioneStato
        : subject.generalita?.luogoNascita?.comune?.nomeComune) || '',
    residence: subject.indirizzo || '',
    drivingLicense: subject.autoveicoli?.possessoPatente === '1' ? 'S' : 'N',
    auto: subject.autoveicoli?.possessoAutoveicoli === '1' ? 'S' : 'N',
    aire: subject.generalita?.soggettoAIRE || '',
    subject,
    selectedFromDb: subject.selected || false,
    idAnprIntestatario: subject.idAnprIntestatario || '',
    intestatario: subject.intestatario || false,
    generality: {
      gender: subject.generalita?.sesso || '',
    },
    posizionePersona: subject.posizionePersona,
    idAnpr: subject.idAnprFamiglia || '',
  }));
};
